module.exports = __webpack_public_path__ + "static/formheader-d8b969de010ea81b6448e382c9426dfc.png";